import { queryService } from "@/services/QueryService";
import { processJson } from "../../../../../api/general.api";

export async function fetchFellingDescriptions(lpo_id) {
  const params = { lpo_id };
  const result = queryService.get("/felling_description/list", params);
  return result;
}

export async function addFellingDescription(lpo_id, description) {
  const params = {
    lpo_id,
    state_cat_id: description.state_cat_id,
    description_id: description.description_id,
  };
  const result = queryService.post("/felling_description/add", params);
  return result;
}

export async function removeFellingDescription(description_id) {
  // const params = {
  //   description_id,
  // };
  // const result = queryService.post("/felling_description/remove", params);
  // return result;

  const json_obj = [
    {
      d: [
        {
          tab_name: "data_lpo_felling_descriptions",
          id: description_id,
        },
      ],
    },
  ];

  const json_str = JSON.stringify(json_obj);
  const response = await processJson(json_str);
  return response;
}
export async function removeFellingDescriptions(descriptions) {
  const arr_d = descriptions.map((description) => {return {tab_name: "data_lpo_felling_descriptions", id: description.id}}).filter((e) => { return e.id !== null })
  const json_obj = [
    {
      d: arr_d,
    },
  ];
  const json_str = JSON.stringify(json_obj);
  const response = await processJson(json_str);
  return response;
}
